import { environment } from '../../environment'
import { endpoints } from './endpoints'
import get from 'lodash.get'

export const apiBaseUrl = environment.REACT_APP_API_BASE_URL
let store

export const injectStore = _store => {
  store = _store
}

const authenticate = (userCode, password, abortController = new AbortController()) => {
  const fetchPromise = fetch(apiBaseUrl + endpoints.authenticate(), {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ username: userCode, password }),
    signal: abortController.signal,
  }).then(fetchThenHandler)
  return { fetchPromise, abortController }
}

const authenticateRefresh = (refreshToken, abortController = new AbortController()) => {
  const fetchPromise = fetch(apiBaseUrl + endpoints.authenticateRefresh(), {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ refreshToken }),
    signal: abortController.signal,
  }).then(fetchThenHandler)
  return { fetchPromise, abortController }
}

const fetchAllSuppliers = (abortController = new AbortController()) => {
  const token = get(store.getState(), 'user.token', '')
  const fetchPromise = fetch(apiBaseUrl + endpoints.getAllSuppliers(), {
    method: 'GET',
    cache: 'no-cache',
    headers: {
      'X-GIATA-JWT-TOKEN': `Bearer ${token}`,
    },
    signal: abortController.signal,
  }).then(fetchThenHandler)
  return { fetchPromise, abortController }
}

const createSupplierList = (supplierId, eMailAddress, abortController = new AbortController()) => {
  const token = get(store.getState(), 'user.token', '')
  const body = { supplierId }
  if (eMailAddress) {
    body.eMailAddress = eMailAddress
  }

  const fetchPromise = fetch(apiBaseUrl + endpoints.createJob(), {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      'X-GIATA-JWT-TOKEN': `Bearer ${token}`,
    },
    body: JSON.stringify(body),
    signal: abortController.signal,
  }).then(fetchThenHandler)
  return { fetchPromise, abortController }
}

const fetchAllSupplierLists = (abortController = new AbortController()) => {
  const token = get(store.getState(), 'user.token', '')

  const fetchPromise = fetch(apiBaseUrl + endpoints.getAllSupplierLists(), {
    method: 'GET',
    cache: 'no-cache',
    headers: {
      'X-GIATA-JWT-TOKEN': `Bearer ${token}`,
    },
    signal: abortController.signal,
  }).then(fetchThenHandler)
  return { fetchPromise, abortController }
}

const fetchDownloadToken = (supplierId, abortController = new AbortController()) => {
  const token = get(store.getState(), 'user.token', '')

  const fetchPromise = fetch(apiBaseUrl + endpoints.getDownloadToken(supplierId), {
    method: 'GET',
    cache: 'no-cache',
    headers: {
      'X-GIATA-JWT-TOKEN': `Bearer ${token}`,
    },
    signal: abortController.signal,
  }).then(fetchThenHandler)
  return { fetchPromise, abortController }
}

const fetchThenHandler = async (response) => {
  if (response.status === 401) {
    throw new Error('NOT_AUTHORIZED')
  }
  if (!response.ok) {
    throw new Error(`Request failed. Status: ${response.status}, Response body: ${JSON.stringify(await response.json())}`)
  }
  return response.json()
}

export const apiService = {
  authenticate,
  authenticateRefresh,
  fetchAllSuppliers,
  createSupplierList,
  fetchAllSupplierLists,
  fetchDownloadToken,
}

export default apiService
